import { useTranslation } from '../../localization/useTranslation';
import React, { useCallback } from 'react';
import { Flex, FlexItem, Radio } from '@patternfly/react-core';
import _ from 'lodash';
import PropTypes from 'prop-types';

const RadioGroup = ({ radios, value, onValueChanged, direction = 'row', spaceItems = 'spaceItemsSm', isDisabled = false }) => {
  const T = useTranslation();

  const _onChange = useCallback((evt, unusedChecked) => {
    onValueChanged(evt.target.id);
  }, [onValueChanged]);

  return (
    <Flex direction={{ default: direction }} spaceItems={{ default: spaceItems }}>
      { _.map(radios, radio => {
        return (<FlexItem key={radio.id}>
          <Radio
            name={radio.name}
            id={radio.id}
            label={T.localize(radio.label)}
            isChecked={radio.id === value}
            onChange={_onChange}
            isDisabled={isDisabled}
          />
        </FlexItem>);
      }) }

    </Flex>
  );
};

const RadioType = PropTypes.shape({
  name: PropTypes.string, // For group of radios, Patternfly Radio has this property as requirement but does not seem to use it, so we keep it optional.
  id: PropTypes.string.isRequired,
  label: PropTypes.string
});

RadioGroup.propTypes = {
  radios: PropTypes.arrayOf(RadioType),
  value: PropTypes.any.isRequired,
  onValueChanged: PropTypes.func,
  direction: PropTypes.string,
  spaceItems: PropTypes.string
};

export default React.memo(RadioGroup);
